(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
var sanikbPublicText_header_1 = JSON.parse(document.getElementById("SanikbPublicText-header-1").textContent);

  document.addEventListener('DOMContentLoaded', function () {
    var header = document.querySelector('.skh');
    if (!header) return;

    var headerWrapper = header.closest('.header-wrapper');
    var sectionRoot = header.closest('[id^="shopify-section-"]');

    function forceFixedHeader() {
      var h = Math.ceil(header.offsetHeight || 80);
      document.documentElement.style.setProperty('--skh-header-height', h + 'px');
      document.documentElement.style.setProperty('--skh-fixed-offset', h + 'px');
      document.body && document.body.style.setProperty('--skh-fixed-offset', h + 'px');

      if (sectionRoot) {
        sectionRoot.classList.add('shopify-section-header-sticky');
        sectionRoot.classList.remove('shopify-section-header-hidden');
        sectionRoot.classList.toggle('is-scrolled', (window.pageYOffset || document.documentElement.scrollTop) > 8);
        sectionRoot.style.position = 'fixed';
        sectionRoot.style.top = '0';
        sectionRoot.style.left = '0';
        sectionRoot.style.right = '0';
        sectionRoot.style.width = '100%';
        sectionRoot.style.zIndex = '880';
        sectionRoot.style.transform = 'none';
        sectionRoot.style.opacity = '1';
        sectionRoot.style.visibility = 'visible';
      }

      if (headerWrapper) {
        headerWrapper.classList.add('shopify-section-header-sticky');
        headerWrapper.classList.remove('shopify-section-header-hidden');
        headerWrapper.style.position = 'relative';
        headerWrapper.style.top = 'auto';
        headerWrapper.style.left = 'auto';
        headerWrapper.style.right = 'auto';
        headerWrapper.style.width = '100%';
        headerWrapper.style.transform = 'none';
        headerWrapper.style.opacity = '1';
        headerWrapper.style.visibility = 'visible';
      }
    }

    forceFixedHeader();
    window.addEventListener('resize', forceFixedHeader);
    window.addEventListener('scroll', forceFixedHeader, { passive: true });
    window.setTimeout(forceFixedHeader, 250);
    window.setTimeout(forceFixedHeader, 1000);

    var smModal = document.getElementById('skh-search-modal');
    var searchBtnDesktop = document.querySelector('.skh-actions .skh-search-btn');
    var mobileMq = window.matchMedia('(max-width: 1080px)');

    var smReturnFocus = null, smFocusTimer = null;

    function closeSearchDropdown(returnFocus) {
      if (!smModal) return;
      var restore = returnFocus && smModal.contains(document.activeElement);
      clearTimeout(smFocusTimer);
      smFocusTimer = null;
      smModal.classList.remove('is-open');
      smModal.classList.remove('is-loading');
      smModal.setAttribute('aria-hidden', 'true');
      smModal.setAttribute('aria-busy', 'false');
      if (searchBtnDesktop) {
        searchBtnDesktop.classList.remove('is-active');
        searchBtnDesktop.setAttribute('aria-expanded', 'false');
      }
      if (mobileMq.matches) document.body.classList.remove('skh-md-locked');
      if (scrim) scrim.classList.remove('is-open');
      if (restore && smReturnFocus && document.documentElement.contains(smReturnFocus) && smReturnFocus.getClientRects().length) {
        smReturnFocus.focus({ preventScroll: true });
      }
      smReturnFocus = null;
    }

    var scrim = document.querySelector('.skh-scrim');
    if (scrim && scrim.parentNode !== document.body) document.body.appendChild(scrim);
    /* Move full-screen overlays to <body> so their z-index escapes the header section's
       stacking context (the header section sits at z-index:3, below the top utility bar's
       section at z-index:1100; without this the bar paints over the open drawer/search). */
    var mdEl = document.getElementById('skh-mobile-drawer');
    if (mdEl && mdEl.parentNode !== document.body) document.body.appendChild(mdEl);
    var smEl = document.getElementById('skh-search-modal');
    if (smEl && smEl.parentNode !== document.body) document.body.appendChild(smEl);
    var ddItems = Array.prototype.slice.call(document.querySelectorAll('.skh-nav-item.has-dd'));
    var desktopMq = window.matchMedia('(min-width: 1081px)');

    if (scrim && ddItems.length) {
      function updateTrigger(item, expanded) {
        var trigger = item.querySelector('.skh-dd-toggle');
        if (trigger) trigger.setAttribute('aria-expanded', String(expanded));
      }
      function syncMegaState() {
        var hasOpen = ddItems.some(function (item) { return item.classList.contains('is-open'); });
        scrim.classList.toggle('is-open', hasOpen && desktopMq.matches);
        header.classList.toggle('is-mega-open', hasOpen && desktopMq.matches);
      }
      function closeItem(item, immediate) {
        window.clearTimeout(item._closeTimer);
        var performClose = function () { item.classList.remove('is-open'); updateTrigger(item, false); syncMegaState(); };
        if (immediate) performClose();
        else item._closeTimer = window.setTimeout(performClose, 350);
      }
      function closeAll(exceptItem, immediate) {
        ddItems.forEach(function (item) { if (item !== exceptItem) { window.clearTimeout(item._openTimer); closeItem(item, immediate); } });
      }
      function openItem(item) {
        item.classList.remove('is-esc-closed'); /* [Claude 2026-10-21] A11Y-02 */
        window.clearTimeout(item._closeTimer);
        window.clearTimeout(item._openTimer);
        closeAll(item, true);
        closeSearchDropdown();
        item.classList.add('is-open');
        updateTrigger(item, true);
        syncMegaState();
      }
      ddItems.forEach(function (item) {
        var trigger = item.querySelector('.skh-dd-toggle');
        item.addEventListener('mouseenter', function () {
        window.clearTimeout(item._closeTimer);
        if (!desktopMq.matches) return;
        /* 2026-09-22 老板:「悬停之后点击下面的过程中,容易收起来」。
           ⛔ 真因不是关得太快(closeItem 已有 350ms 宽限),而是 openItem() 里 closeAll(item, true) 是
              **立即**关闭:鼠标沿导航栏横向移动、蹭过旁边一个顶级项就瞬间切走,宽限对这条路径完全无效。
           ⇒ 已有菜单开着时,切换需要停留 140ms 才算意图;一掠而过不算。首次打开仍即时。 */
        if (item.classList.contains('is-open')) return;
        var anyOpen = ddItems.some(function (x) { return x.classList.contains('is-open'); });
        if (!anyOpen) { openItem(item); return; }
        window.clearTimeout(item._openTimer);
        item._openTimer = window.setTimeout(function () {
          if (desktopMq.matches) openItem(item);
        }, 140);
      });
        /* v12.1 forgiving hover-intent: the mega panel is a DOM child of `item`, so hovering the panel keeps `item` "entered". Crossing the small gap between the trigger and the panel fires mouseleave, but the 350ms grace in closeItem() — cancelled the instant the pointer re-enters the trigger or panel — tolerates the transit, so the mega no longer collapses before you reach it. It still closes shortly after you move fully away, or immediately on a deliberate action (scrim / outside click, Esc, hovering another top item, opening search — all handled below). */
        item.addEventListener('mouseleave', function () {
        window.clearTimeout(item._openTimer);   /* 掠过就走 ⇒ 取消待切换 */
        if (desktopMq.matches) closeItem(item, false);
      });
        item.addEventListener('focusin', function () { if (item._escFocus) { item._escFocus = false; return; } openItem(item); }); /* [Claude 2026-10-21] A11Y-02: focus returned by Esc does not reopen */
        item.addEventListener('focusout', function () {
          window.requestAnimationFrame(function () { if (!item.contains(document.activeElement)) { item.classList.remove('is-esc-closed'); closeItem(item, true); } }); /* [Claude 2026-10-21] A11Y-02 */
        });
        if (trigger) {
          var isAnchorTrigger = trigger.tagName.toLowerCase() === 'a';
          trigger.addEventListener('click', function (e) {
            if (isAnchorTrigger) return;
            e.preventDefault(); e.stopPropagation();
            if (item.classList.contains('is-open')) closeItem(item, true); else openItem(item);
          });
        }
      });
      document.addEventListener('pointerdown', function (e) {
        var inside = ddItems.some(function (item) { return item.contains(e.target); });
        if (!inside) closeAll(null, true);
      });
      scrim.addEventListener('click', function () { closeAll(null, true); });
      /* [Claude 2026-10-21] A11Y-02: Esc also hides a panel that is open only through :hover / :focus-within, and moves focus
         from inside the panel back to its trigger (that focusin does not reopen). Hover / focus opening is unchanged; the flag
         clears on the next open or when focus leaves the item. Every item shown by focus OR hover is closed (pointer on one
         item while focus is in another left the hovered panel up). [Claude 2026-10-21 review] */
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var hosts = ddItems.filter(function (x) { return x.contains(document.activeElement) || x.matches(':hover'); });
        closeAll(null, true);
        hosts.forEach(function (host) {
          host.classList.add('is-esc-closed');
          var t = host.querySelector('.skh-dd-toggle'), mm = host.querySelector('.skh-mm');
          if (t && mm && mm.contains(document.activeElement)) { host._escFocus = true; t.focus({ preventScroll: true }); }
        });
      });
    }

    var mdDrawer = document.getElementById('skh-mobile-drawer');
    var mdOpenBtn = document.querySelector('[data-skh-md-open]');
    var mdCloseBtn = document.querySelector('[data-skh-md-close]');
    var mdToggles = document.querySelectorAll('[data-skh-md-toggle]');
    var mdReturnFocus = null, mdFocusTimer = null;

    function mdTabStops() {
      if (!mdDrawer) return [];
      return Array.prototype.filter.call(mdDrawer.querySelectorAll('a[href], button, input, select, textarea, [tabindex]'), function (el) {
        return !el.disabled && el.tabIndex >= 0 && el.getClientRects().length > 0 && window.getComputedStyle(el).visibility !== 'hidden';
      });
    }

    function openMd() {
      if (!mdDrawer || mdDrawer.classList.contains('is-open')) return;
      mdReturnFocus = mdOpenBtn || document.activeElement;
      mdDrawer.classList.add('is-open'); mdDrawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('skh-md-locked');
      if (mdOpenBtn) mdOpenBtn.setAttribute('aria-expanded', 'true');
      /* Mount the search INLINE at the top of the drawer (no jump to the floating modal) */
      var skSlot = mdDrawer.querySelector('[data-skh-search-slot]');
      if (skSlot && typeof smModal !== 'undefined' && smModal) {
        skSlot.appendChild(smModal);
        smModal.classList.add('skh-sm--inline', 'is-open');
        smModal.setAttribute('aria-hidden', 'false');
        try { renderInitial(); } catch (e) {}
      }
      clearTimeout(mdFocusTimer);
      mdFocusTimer = setTimeout(function () {
        mdFocusTimer = null;
        if (!mdDrawer.classList.contains('is-open') || mdDrawer.contains(document.activeElement)) return;
        var stops = mdTabStops();
        (mdCloseBtn || stops[0] || mdDrawer).focus({ preventScroll: true });
      }, 60);
    }
    function closeMd() {
      if (!mdDrawer || !mdDrawer.classList.contains('is-open')) return;
      clearTimeout(mdFocusTimer);
      mdFocusTimer = null;
      mdDrawer.classList.remove('is-open'); mdDrawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('skh-md-locked');
      if (mdOpenBtn) mdOpenBtn.setAttribute('aria-expanded', 'false');
      /* Return the search to its floating-modal home so the desktop/header search still works */
      if (typeof smModal !== 'undefined' && smModal && smModal.classList.contains('skh-sm--inline')) {
        smModal.classList.remove('skh-sm--inline', 'is-open');
        smModal.setAttribute('aria-hidden', 'true');
        if (typeof smInput !== 'undefined' && smInput) smInput.value = '';
        document.body.appendChild(smModal);
      }
      if (mdReturnFocus && document.documentElement.contains(mdReturnFocus) && mdReturnFocus.getClientRects().length) {
        mdReturnFocus.focus({ preventScroll: true });
      }
      mdReturnFocus = null;
    }
    if (mdOpenBtn) mdOpenBtn.addEventListener('click', openMd);
    if (mdCloseBtn) mdCloseBtn.addEventListener('click', closeMd);

    if (mdDrawer) {
      var mdInternalLinks = mdDrawer.querySelectorAll('a[href]');
      Array.prototype.forEach.call(mdInternalLinks, function (a) {
        a.addEventListener('click', function () { setTimeout(closeMd, 50); });
      });
    }

    Array.prototype.forEach.call(mdToggles, function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var item = btn.closest('.skh-md-item'); if (!item) return;
        var isOpen = item.classList.contains('is-open');
        var siblings = item.parentElement.querySelectorAll('.skh-md-item');
        Array.prototype.forEach.call(siblings, function (sib) {
          if (sib !== item) {
            sib.classList.remove('is-open');
            var sibBtn = sib.querySelector('[data-skh-md-toggle]');
            if (sibBtn) sibBtn.setAttribute('aria-expanded', 'false');
          }
        });
        item.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    document.addEventListener('keydown', function (e) {
      if (!mdDrawer || !mdDrawer.classList.contains('is-open')) return;
      if (e.key === 'Escape') { e.preventDefault(); closeMd(); return; }
      if (e.key !== 'Tab') return;
      var stops = mdTabStops(), first = stops[0], last = stops[stops.length - 1];
      var active = document.activeElement;
      if (!stops.length) { e.preventDefault(); mdDrawer.focus({ preventScroll: true }); return; }
      if (!mdDrawer.contains(active) || active === mdDrawer || (e.shiftKey && active === first) || (!e.shiftKey && active === last)) {
        e.preventDefault();
        (e.shiftKey ? last : first).focus({ preventScroll: true });
      }
    });
    window.matchMedia('(min-width: 1081px)').addEventListener('change', function (e) { if (e.matches) closeMd(); });

    if (!smModal) return;
    var smOpenBtns = document.querySelectorAll('[data-skh-search-open]');
    var smCloseBtns = document.querySelectorAll('[data-skh-search-close]');
    var smInput = smModal.querySelector('[data-skh-search-input]');
    var smClear = smModal.querySelector('[data-skh-search-clear]');
    var smBody = smModal.querySelector('[data-skh-search-body]');
    var smForm = smModal.querySelector('[data-skh-search-form]');
    var popularRaw = smModal.getAttribute('data-popular') || '';
    var quoteUrl = smModal.getAttribute('data-quote-url') || '/pages/contact';
    var popular = popularRaw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);

    var RECENT_KEY = 'skh_recent_searches' + (window.SanikbPublicI18n.root === '/' ? '' : ':' + window.SanikbPublicI18n.root);
    var MAX_RECENT = 6, SEARCH_DEBOUNCE_MS = 140, LOADING_DELAY_MS = 200, EMPTY_REDIRECT_MS = 900, MAX_CACHE = 30;
    var debounceTimer = null, loadingTimer = null, emptyRedirectTimer = null, lastQuery = '';
    var activeFetch = null, activeIndex = -1, currentRows = [], searchCache = {}, cacheKeys = [], userMovedSelection = false;

    function escapeHtml(str) {
      if (str == null) return '';
      return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
    }
    function highlight(text, q) {
      if (!text) return '';
      var safe = escapeHtml(text);
      if (!q) return safe;
      var qSafe = escapeHtml(q).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      try { return safe.replace(new RegExp('(' + qSafe + ')', 'ig'), '<mark>$1</mark>'); }
      catch (e) { return safe; }
    }
    function getRecent() {
      try { var raw = localStorage.getItem(RECENT_KEY); if (!raw) return []; var arr = JSON.parse(raw); return Array.isArray(arr) ? arr : []; } catch (e) { return []; }
    }
    function saveRecent(q) {
      if (!q || q.length < 2) return;
      try {
        var list = getRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
        list.unshift(q); list = list.slice(0, MAX_RECENT);
        localStorage.setItem(RECENT_KEY, JSON.stringify(list));
      } catch (e) {}
    }
    function clearRecent() { try { localStorage.removeItem(RECENT_KEY); } catch (e) {} }
    function cacheGet(q) { var k = q.toLowerCase(); return Object.prototype.hasOwnProperty.call(searchCache, k) ? searchCache[k] : null; }
    function cacheSet(q, data) {
      var k = q.toLowerCase();
      if (!Object.prototype.hasOwnProperty.call(searchCache, k)) {
        cacheKeys.push(k);
        if (cacheKeys.length > MAX_CACHE) { var oldest = cacheKeys.shift(); delete searchCache[oldest]; }
      }
      searchCache[k] = data;
    }
    function clearAllTimers() {
      if (debounceTimer) { clearTimeout(debounceTimer); debounceTimer = null; }
      if (loadingTimer) { clearTimeout(loadingTimer); loadingTimer = null; }
      if (emptyRedirectTimer) { clearTimeout(emptyRedirectTimer); emptyRedirectTimer = null; }
    }

    /* ============================================================
       LOCAL FUZZY SEARCH ENGINE — substring SKU · typo · synonyms.
       Loads /products.json once, caches a slim index in localStorage
       (12h), then matches entirely client-side. If products.json is
       unavailable it falls back to Shopify suggest.json (legacy path).
       ============================================================ */
    var IDX_KEY = 'skh_pidx_v1' + (window.SanikbPublicI18n.root === '/' ? '' : ':' + window.SanikbPublicI18n.root);
    var IDX_TTL = 12 * 60 * 60 * 1000;
    var PRODUCT_LIMIT = 8;
    var localRecords = null, localVocab = null, localReady = false, indexLoading = null;

    function skNorm(s) { return (s == null ? '' : String(s)).toLowerCase().replace(/\s+/g, ' ').trim(); }
    function skCompact(s) { return (s == null ? '' : String(s)).toLowerCase().replace(/[^a-z0-9]+/g, ''); }
    function skWords(s) { return skNorm(s).split(/[^a-z0-9]+/).filter(function (w) { return w.length >= 1; }); }
    function skStem(w) { return (w.length > 3 && w.charAt(w.length - 1) === 's') ? w.slice(0, -1) : w; }
    function skTagValue(tag) { var i = String(tag).indexOf(':'); return i >= 0 ? String(tag).slice(i + 1) : String(tag); }
  var SK_CODE_JOIN = /(^|[^a-z0-9])([a-z]{1,3})[-.]+(?=[0-9])/g;
  function skSkuWords(skus) { var s = skus.join(' ').toLowerCase(), a = skWords(s).concat(skWords(s.replace(SK_CODE_JOIN, '$1$2'))), o = {}; for (var i = 0; i < a.length; i++) if (/[0-9]/.test(a[i]) ? !/^[0-9]{1,2}$/.test(a[i]) : a[i].length >= 4) o[a[i]] = 1; return Object.keys(o); }

    /* single-token synonyms — query token maps to extra tokens to also match. Extend freely. */
    var SK_TOKEN_SYN = { washer: ['laundry','utility'], utility: ['laundry'], laundry: ['utility'], butler: ['farmhouse','apron'], buttler: ['farmhouse','apron'], belfast: ['farmhouse','apron'], bol: ['bowl'],
      tap: ['faucet','mixer'], taps: ['faucet','mixer'], mixer: ['faucet'], spigot: ['faucet'], tapware: ['faucet'],
      basin: ['sink','washbasin'], washbasin: ['basin','sink'], lavatory: ['basin','sink'], lav: ['basin','sink'],
      farmhouse: ['apron','farm'], farm: ['farmhouse','apron'], apron: ['farmhouse'],
      undermount: ['undermount'], undercounter: ['undermount'],
      ss: ['stainless','steel'], inox: ['stainless','steel'], stainless: ['steel'],
      gunmetal: ['black'], champagne: ['gold'],
      toilet: ['toilet','wc','commode'], wc: ['toilet'], commode: ['toilet'], loo: ['toilet'], bidet: ['bidet'],
      worktop: ['workstation'], workstation: ['workstation'],
      vessel: ['vessel','countertop'], countertop: ['vessel','countertop']
    };
    /* multi-word phrases — append extra query terms before matching */
    var SK_PHRASE_SYN = [
      ['pull down','pulldown'], ['pull-down','pulldown'],
      ['matte black','gunmetal'], ['matt black','gunmetal'],
      ['brushed gold','champagne'], ['brushed brass','champagne'],
      ['brushed nickel','nickel'], ['wash basin','basin'],
      ['double bowl','double'], ['single bowl','single']
    ];
    function skExpand(t) {
      var out = {}; out[t] = 1; out[skStem(t)] = 1;
      var syn = SK_TOKEN_SYN[t] || SK_TOKEN_SYN[skStem(t)];
      if (syn) for (var i = 0; i < syn.length; i++) out[syn[i]] = 1;
      return Object.keys(out);
    }

    /* Damerau-Levenshtein (optimal string alignment) with early bound — counts transpositions (isnk->sink = 1) */
    function skDamerau(a, b, max) {
      var al = a.length, bl = b.length;
      if (Math.abs(al - bl) > max) return max + 1;
      if (a === b) return 0;
      var prev2 = [], prev = [], cur = [], i, j;
      for (j = 0; j <= bl; j++) prev[j] = j;
      for (i = 1; i <= al; i++) {
        cur[0] = i; var best = i;
        for (j = 1; j <= bl; j++) {
          var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
          var v = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
          if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) v = Math.min(v, prev2[j - 2] + 1);
          cur[j] = v; if (v < best) best = v;
        }
        if (best > max) return max + 1;
        prev2 = prev.slice(); prev = cur.slice();
      }
      return prev[bl];
    }
    function skThresh(len) { return len <= 6 ? 1 : 2; }
    /* near model numbers (2026-09-29): used ONLY when nothing matches as typed. Only digits may differ:
       1-2 digits missing, 1 extra, 1 wrong, or 2 adjacent swapped; letters must match; >= 4 chars and >= 3 digits. */
    function skNearCode(q, c) {
      var ql = q.length, cl = c.length, i, j, d;
      var qd = q.replace(/\D/g, '').length, cd = c.replace(/\D/g, '').length;
      if (ql < 4 || cl < 4 || cl > 16 || qd < 2 || cd < 2 || (qd < 3 && !/[a-z]/.test(q)) || (cd < 3 && !/[a-z]/.test(c))) return 0;
      if (cl - ql === 1 || cl - ql === 2) {
        for (i = 0, j = 0, d = 0; j < cl; j++) { if (i < ql && q.charAt(i) === c.charAt(j)) i++; else if (/[0-9]/.test(c.charAt(j))) d++; else return 0; }
        return (i === ql && d === cl - ql) ? d : 0;
      }
      if (ql - cl === 1) {
        for (i = 0, j = 0, d = 0; i < ql; i++) { if (j < cl && q.charAt(i) === c.charAt(j)) j++; else if (/[0-9]/.test(q.charAt(i))) d++; else return 0; }
        return (j === cl && d === 1) ? 1 : 0;
      }
      if (ql === cl) {
        var df = []; for (i = 0; i < ql; i++) if (q.charAt(i) !== c.charAt(i)) { df.push(i); if (df.length > 2) return 0; }
        if (df.length === 1) return (/[0-9]/.test(q.charAt(df[0])) && /[0-9]/.test(c.charAt(df[0]))) ? 1 : 0;
        if (df.length === 2 && df[1] === df[0] + 1 && q.charAt(df[0]) === c.charAt(df[1]) && q.charAt(df[1]) === c.charAt(df[0]) && /[0-9]/.test(q.charAt(df[0])) && /[0-9]/.test(q.charAt(df[1]))) return 1;
      }
      return 0;
    }
    function skNearScore(q, rec) {
      var qd0 = q.replace(/\D/g, '').length; if (q.length < 4 || qd0 < 2 || (qd0 < 3 && !/[a-z]/.test(q))) return 0;
      var best = 0, toks = rec.ctoks.concat(rec.skuw), t, e, cp, sc, n0 = toks.length;
      for (t = 0; t < n0; t++) if (/[0-9][lr]$/.test(toks[t])) toks.push(toks[t].slice(0, -1));
      for (t = 0; t < toks.length; t++) {
        e = toks[t] === q ? -1 : skNearCode(q, toks[t]); if (!e) continue;
        for (cp = 0; cp < q.length && q.charAt(cp) === toks[t].charAt(cp); cp++);
        sc = (e === -1 ? 50 : e === 1 ? 30 : 20) + Math.min(cp, 8); if (sc > best) best = sc;
      }
      return best;
    }

    function skHydrate(slim) {
      var recs = new Array(slim.length);
      for (var k = 0; k < slim.length; k++) {
        var p = slim[k], skus = p.s || [], tags = p.tg || [];
        var tagWords = []; for (var t = 0; t < tags.length; t++) tagWords.push(skTagValue(tags[t]));
        var title = p.t || '';
        var words = skWords(title + ' ' + (p.ty || '') + ' ' + (p.v || '') + ' ' + tagWords.join(' '));
        var dims = title.toLowerCase().match(/(^|[^\d.])\d+\s*[x\u00d7*]\s*\d+(?![\d.])/g) || []; for (var dmi = 0; dmi < dims.length; dmi++) { var dmw = dims[dmi].replace(/^[^\d]/, '').replace(/\s+/g, '').replace(/[\u00d7*]/g, 'x'); if (words.indexOf(dmw) < 0) words.push(dmw); }
        var ctoks = {}, src = skWords(title + ' ' + (p.h || '') + ' ' + skus.join(' '));
        for (var w = 0; w < src.length; w++) { var c = skCompact(src[w]); if (c.length >= 2) ctoks[c] = 1; }
        var joined = [p.h].concat(skus);
        for (var jx = 0; jx < joined.length; jx++) { var cj = skCompact(joined[jx]); if (cj.length >= 2) ctoks[cj] = 1; }
        var tagset = []; for (var tg = 0; tg < tags.length; tg++) tagset.push(skTagValue(tags[tg]).toLowerCase());
        recs[k] = { title: title, url: '/products/' + (p.h || ''), product_type: p.ty || '', vendor: p.v || '', img: p.img || '', words: words, ctoks: Object.keys(ctoks), tagset: tagset, skuw: skSkuWords(skus) };
      }
      var vocab = {};
      for (var r = 0; r < recs.length; r++) { var ww = recs[r].words.concat(recs[r].skuw); for (var x = 0; x < ww.length; x++) vocab[ww[x]] = 1; }
      localRecords = recs; localVocab = vocab; localReady = true;
      return recs;
    }
    function skReadCache() {
      try { var raw = localStorage.getItem(IDX_KEY); if (!raw) return null; var o = JSON.parse(raw); if (!o || o.v !== 2 || !o.recs) return null; if (Date.now() - (o.ts || 0) > IDX_TTL) return null; return o.recs; } catch (e) { return null; }
    }
    function skWriteCache(slim) { try { localStorage.setItem(IDX_KEY, JSON.stringify({ v: 2, ts: Date.now(), recs: slim })); } catch (e) {} }
    function skFetchAll() {
      var all = [];
      function page(n) {
        return fetch(window.SanikbPublicI18n.url('/products.json?limit=250&page=') + n, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('products.json ' + r.status); return r.json(); })
          .then(function (d) {
            var ps = (d && d.products) || [];
            for (var i = 0; i < ps.length; i++) {
              var p = ps[i], skus = [];
              var vs = p.variants || []; for (var v = 0; v < vs.length; v++) if (vs[v].sku) skus.push(vs[v].sku);
              var img = (p.images && p.images[0] && p.images[0].src) || '';
              all.push({ t: p.title, h: p.handle, ty: p.product_type, v: p.vendor, s: skus, tg: p.tags || [], img: img });
            }
            if (ps.length === 250 && n < 20) return page(n + 1);
            return all;
          });
      }
      return page(1);
    }
    function ensureIndex() {
      if (localReady) return Promise.resolve(localRecords);
      if (indexLoading) return indexLoading;
      var cached = skReadCache();
      if (cached) { skHydrate(cached); return Promise.resolve(localRecords); }
      indexLoading = skFetchAll().then(function (slim) { skWriteCache(slim); skHydrate(slim); indexLoading = null; return localRecords; })
        .catch(function (e) { indexLoading = null; localReady = false; throw e; });
      return indexLoading;
    }

    var SK_INCH_RE = /(\d+(?:\.\d+)?)\s*(?:inches|inch|in|"|”|''|’’)\b/g;
    function skBuildContext(raw) {
      var base = skNorm(raw);
      /* interpretation A: the literal query (inch units stripped) */
      var qa = base.replace(SK_INCH_RE, '$1');
      /* interpretation B: phrase synonyms + mm->inch applied (OR-alternative to A, never AND) */
      var qb = base, changed = false;
      for (var i = 0; i < SK_PHRASE_SYN.length; i++) {
        if (qb.indexOf(SK_PHRASE_SYN[i][0]) >= 0) { qb = qb.split(SK_PHRASE_SYN[i][0]).join(SK_PHRASE_SYN[i][1]); changed = true; }
      }
      qb = qb.replace(/(\d+(?:\.\d+)?)\s*mm\b/g, function (m, n) { changed = true; return String(Math.round(parseFloat(n) / 25.4)); });
      qb = qb.replace(SK_INCH_RE, '$1');

      var ta = skWords(qa), termsA = [];
      for (var a = 0; a < ta.length; a++) termsA.push({ variants: skExpand(ta[a]) });
      var sets = [termsA];
    var qdm = qa.replace(/(^|[^\d.])(\d+)\s*[x\u00d7*]\s*(\d+)(?![\d.])/g, '$1$2x$3');
    if (qdm !== qa) { var tdm = skWords(qdm), termsD = []; for (var dj = 0; dj < tdm.length; dj++) termsD.push({ variants: skExpand(tdm[dj]) }); if (termsD.length) sets.push(termsD); }
    var qc = qa.replace(SK_CODE_JOIN, '$1$2');
    if (qc !== qa) { var tj = skWords(qc), termsJ = []; for (var j = 0; j < tj.length; j++) termsJ.push({ variants: skExpand(tj[j]) }); if (termsJ.length) sets.push(termsJ); }
      if (changed && qb !== qa) {
        var tb = skWords(qb), termsB = [];
        for (var b = 0; b < tb.length; b++) termsB.push({ variants: skExpand(tb[b]) });
        if (termsB.length) sets.push(termsB);
      }
      var compactQ = skCompact(ta.join(''));
      /* did-you-mean: first alphabetic word (>=4, no digit) not in vocab and not a prefix -> nearest vocab word */
      var dym = null;
      if (localVocab) {
        for (var ti = 0; ti < ta.length; ti++) {
          var term = ta[ti];
          if (term.length < 4 || /[0-9]/.test(term) || localVocab[term]) continue;
          var th = skThresh(term.length), isPrefix = false, bestW = null, bestD = th + 1;
          for (var wv in localVocab) {
            if (wv.indexOf(term) === 0) { isPrefix = true; break; }
            if (Math.abs(wv.length - term.length) > th) continue;
            var dd = skDamerau(term, wv, th); if (dd < bestD) { bestD = dd; bestW = wv; }
          }
          if (!isPrefix && bestW && bestD <= th) { var fixed = ta.slice(); fixed[ti] = bestW; dym = { from: term, to: bestW, query: fixed.join(' ') }; break; }
        }
      }
      return { sets: sets, compactQ: compactQ, rawTerms: ta, dym: dym };
    }

    function skScore(rec, ctx) {
      /* SKU / compact substring — only for queries that contain a digit (real SKUs always do) */
      var sku = 0, ci, ct;
      if (ctx.compactQ.length >= 3 && /[0-9]/.test(ctx.compactQ)) {
        for (ci = 0; ci < rec.ctoks.length; ci++) {
          ct = rec.ctoks[ci];
          if (ct === ctx.compactQ) { sku = 1000; break; }
          var pos = ct.indexOf(ctx.compactQ);
          if (pos === 0) { if (sku < 880) sku = 880; }
          else if (pos > 0) { if (sku < 820) sku = 820; }
        }
      }
      /* word / synonym path — a record passes an interpretation if ALL its terms match; take best interpretation */
      var bestWord = 0;
      for (var s = 0; s < ctx.sets.length; s++) {
        var set = ctx.sets[s];
        if (!set.length) continue;
        var total = 0, ok = true;
        for (var ti = 0; ti < set.length; ti++) {
          var variants = set[ti].variants, best = 0;
          for (var vi = 0; vi < variants.length; vi++) {
            var vt = variants[vi];
            if (rec.tagset.indexOf(vt) >= 0 && best < 95) best = 95;
          for (var si = 0; si < rec.skuw.length; si++) { var sw = rec.skuw[si]; if (sw === vt) { if (best < 100) best = 100; } else if (vt.length >= 4 && /[0-9]/.test(vt) && sw.indexOf(vt) === 0 && best < 78) best = 78; }
            for (var wi = 0; wi < rec.words.length; wi++) {
              var wd = rec.words[wi];
              if (wd === vt) { if (best < 100) best = 100; }
              else if (vt.length >= 2 && wd.indexOf(vt) === 0) { if (best < 78) best = 78; }
              else if (vt.length >= 3 && wd.indexOf(vt) > 0) { if (best < 58) best = 58; }
            }
            /* fuzzy typo tolerance — alphabetic tokens only (never numeric SKUs) */
            if (best < 58 && vt.length >= 4 && !/[0-9]/.test(vt)) {
              var th = skThresh(vt.length);
              for (var fi = 0; fi < rec.words.length; fi++) {
                var fw = rec.words[fi];
                if (fw.length < 3 || /[0-9]/.test(fw) || Math.abs(fw.length - vt.length) > th) continue;
                if (skDamerau(vt, fw, th) <= th) { best = 44; break; }
              }
            }
          }
          if (best === 0 && ctx.near) { var nt = set[ti].variants[0]; if (nt.length >= 4 && /[0-9]/.test(nt) && (/[a-z]/.test(nt) || set.length === 1)) best = skNearScore(nt, rec); }
          if (best === 0) { ok = false; break; }
          total += best;
        }
        if (ok && total > bestWord) bestWord = total;
      }
      var score = bestWord;
      if (sku > score) score = sku;
      if (ctx.near && sku === 0) { var nz = skNearScore(ctx.compactQ, rec); if (nz > score) score = nz; }
      var skuMode = sku > 0 && sku >= bestWord;
      if (score > 0) {
        var tl = skNorm(rec.title), inTitle = 0;
        for (var rti = 0; rti < ctx.rawTerms.length; rti++) { if (ctx.rawTerms[rti] && tl.indexOf(ctx.rawTerms[rti]) >= 0) inTitle++; }
        if (inTitle && bestWord > 0) score += 8 + inTitle * 4;   /* title mentions the query -> above tag-only matches */
        if (ctx.rawTerms[0] && tl.indexOf(ctx.rawTerms[0]) === 0) score += 6;
        score += Math.max(0, 4 - Math.floor(rec.title.length / 18));
      }
      return { score: score, skuMode: skuMode };
    }

    function searchLocal(raw) {
      if (!localReady) return { products: [], total: 0, skuMode: false, dym: null };
      var ctx = skBuildContext(raw), hits = [], skuAny = false, near = false;
      for (var i = 0; i < localRecords.length; i++) {
        var r = skScore(localRecords[i], ctx);
        if (r.score > 0) { hits.push({ rec: localRecords[i], score: r.score }); if (r.skuMode) skuAny = true; }
      }
      if (!hits.length && /[0-9]/.test(ctx.compactQ)) { ctx.near = near = true; for (var n2 = 0; n2 < localRecords.length; n2++) { var r2 = skScore(localRecords[n2], ctx); if (r2.score > 0) hits.push({ rec: localRecords[n2], score: r2.score }); } }
    hits.sort(function (a, b) { return b.score !== a.score ? b.score - a.score : a.rec.title.length - b.rec.title.length; });
      return { products: hits, total: hits.length, skuMode: skuAny, dym: ctx.dym, near: near && hits.length > 0 };
    }

  /* ===== no-dead-end fallback (2026-09-20) — runs ONLY when searchLocal() returns 0.
     T2 closest: whole-word OR match (>= half the content terms, tokens >= 3 chars, synonyms), never substring.
     T3 same series: same alpha prefix + longest common digit run >= 3 (or alpha-only prefix like "rs").
     T4 popular: category noun in the query -> Shopify suggest.json for that noun (live, never stale) -> else SK_POPULAR. */
  var SK_FB_STOP = { sink:1, sinks:1, basin:1, basins:1, and:1, with:1, the:1, for:1, kitchen:1, bathroom:1, inch:1, mm:1, cm:1, sku:1, model:1, set:1, size:1 };
  var SK_FB_NOUNS = ['sink','basin','faucet','tap','toilet','bidet','shower','tub','bathtub','mirror','vanity','urinal','accessor'];
  var SK_POPULAR = ['sn015-18-inch-compact-ceramic-undermount-sink','sn016-narrow-rectangular-ceramic-undermount-sink','sn017-deep-rectangular-ceramic-undermount-sink','sn018-20-inch-rectangular-ceramic-undermount-sink','round-glass-vessel-sink','sn029-series-multi-size-rectangular-ceramic-undermount-sink','sn004-small-oval-ceramic-undermount-sink','sn005-18-inch-oval-ceramic-undermount-sink']; /* GA4 90d PDP views, 2026-09-20 */
  function skFbToks(q) { return String(q || '').toLowerCase().replace(/[^a-z0-9\s\-]/g, ' ').split(/[\s\-]+/).filter(function (t) { return t.length >= 3 && !SK_FB_STOP[t]; }); }
  function skFbExpand(t) { var o = [t]; var s = SK_TOKEN_SYN[t]; if (s) for (var i = 0; i < s.length; i++) o.push(s[i]); return o; }
  function skFbAlpha(s) { var m = /^([a-z]+)/.exec(s); return m ? m[1] : ''; }
  function skFbLcs(a, b) { a = a.replace(/\D/g, ''); b = b.replace(/\D/g, ''); if (!a || !b) return 0; var best = 0; for (var i = 0; i < a.length; i++) for (var j = 0; j < b.length; j++) { var k = 0; while (a[i + k] && a[i + k] === b[j + k]) k++; if (k > best) best = k; } return best; }
  function skFbHasWord(rec, w) { var ws = rec.words || [], ts = rec.tagset || []; for (var i = 0; i < ws.length; i++) if (ws[i] === w) return true; for (var j = 0; j < ts.length; j++) if (ts[j] === w) return true; return false; }
  function skFbClosest(q) {
    var ts = skFbToks(q).filter(function (t) { return !/^\d+$/.test(t); }); if (!ts.length) return [];
    var out = [], i, r, hit, k, vs, v;
    for (i = 0; i < localRecords.length; i++) {
      r = localRecords[i]; hit = 0;
      for (k = 0; k < ts.length; k++) { vs = skFbExpand(ts[k]); for (v = 0; v < vs.length; v++) { if (skFbHasWord(r, vs[v])) { hit++; break; } } }
      if (hit) out.push({ hit: hit, rec: r });
    }
    var need = Math.max(1, Math.ceil(ts.length / 2));
    out = out.filter(function (o) { return o.hit >= need; });
    out.sort(function (a, b) { return b.hit !== a.hit ? b.hit - a.hit : a.rec.title.length - b.rec.title.length; });
    return out.map(function (o) { return o.rec; });
  }
  function skFbSeries(q) {
    var c = String(q || '').toLowerCase().replace(/[\s\-_]/g, ''); var ap = skFbAlpha(c); if (ap.length < 2) return [];
    var hasDigit = /\d/.test(c), out = [], i, r, best, j, ct, l;
    for (i = 0; i < localRecords.length; i++) {
      r = localRecords[i]; best = -1;
      for (j = 0; j < (r.ctoks || []).length; j++) { ct = r.ctoks[j]; if (skFbAlpha(ct) !== ap) continue; l = skFbLcs(c, ct); if (!hasDigit || l >= 3) { if (l > best) best = l; } }
      if (best >= 0) out.push({ l: best, rec: r });
    }
    out.sort(function (a, b) { return b.l - a.l; });
    return out.map(function (o) { return o.rec; });
  }
  function skFbNoun(q) { var ts = String(q || '').toLowerCase().split(/[^a-z]+/), n = null; for (var i = 0; i < ts.length; i++) for (var j = 0; j < SK_FB_NOUNS.length; j++) if (ts[i].indexOf(SK_FB_NOUNS[j]) === 0) n = SK_FB_NOUNS[j]; return n; }
  function skFbPopular(q) {
    var noun = skFbNoun(q) || 'sink';
    var byHandle = {}, i; for (i = 0; i < localRecords.length; i++) byHandle[(localRecords[i].url || '').split('/products/')[1] || ''] = localRecords[i];
    function fromConst() { var o = []; for (var k = 0; k < SK_POPULAR.length; k++) if (byHandle[SK_POPULAR[k]]) o.push(byHandle[SK_POPULAR[k]]); return o; }
    return fetch(window.SanikbPublicI18n.url('/search/suggest.json?q=') + encodeURIComponent(noun) + '&resources[type]=product&resources[limit]=8', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { var ps = (j && j.resources && j.resources.results && j.resources.results.products) || [], o = []; for (var i = 0; i < ps.length; i++) { var h = (ps[i].handle || (ps[i].url || '').split('/products/')[1] || '').split('?')[0]; if (byHandle[h]) o.push(byHandle[h]); } return o.length ? { label: window.SanikbPublicI18n.root === '/' ? 'popular ' + noun + 's' : sanikbPublicText_header_1['header_019_html'], recs: o } : { label: sanikbPublicText_header_1['header_019_html'], recs: fromConst() }; })
      .catch(function () { return { label: sanikbPublicText_header_1['header_019_html'], recs: fromConst() }; });
  }
  /* returns Promise<{tier, label, recs}> ; recs may be [] only if the index itself is empty */
  function skFallback(q) {
    var raw = String(q || ''), alphaOnlyShort = /^[a-z]{2,3}$/i.test(raw.replace(/[\s\-_]/g, ''));
    var series = skFbSeries(raw), closest = alphaOnlyShort ? [] : skFbClosest(raw);
    if (series.length && (/\d/.test(raw) || alphaOnlyShort)) return Promise.resolve({ tier: 'series', label: sanikbPublicText_header_1['header_020_html'], recs: series });
    if (closest.length) return Promise.resolve({ tier: 'closest', label: sanikbPublicText_header_1['header_021_html'], recs: closest });
    if (series.length) return Promise.resolve({ tier: 'series', label: sanikbPublicText_header_1['header_020_html'], recs: series });
    return skFbPopular(raw).then(function (p) { return { tier: 'popular', label: p.label, recs: p.recs }; });
  }


    function emptyMarkup(q) {
      var qEsc = escapeHtml(q);
      return ('<div class="skh-sr-state"><strong class="skh-sr-state-title">' + sanikbPublicText_header_1['header_022_html'] + '</strong>' + sanikbPublicText_header_1['header_023_html'] + '<span class="skh-sr-state-q">&ldquo;') + qEsc + ('&rdquo;</span>' + sanikbPublicText_header_1['header_024_html'] + '</div><a href="/search?q=') + encodeURIComponent(q) + ('" class="skh-sr-cta-primary"><span>' + sanikbPublicText_header_1['header_025_html'] + '<span class="skh-sr-cta-primary-q">&ldquo;') + qEsc + '&rdquo;</span></span><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 8h10M9 4l4 4-4 4"/></svg></a><br><a href="' + escapeHtml(quoteUrl) + ('" class="skh-sr-cta-secondary">' + sanikbPublicText_header_1['header_026_html'] + '</a>');
    }

    /* no-dead-end (2026-09-20): when the smart index has ZERO products for q (regardless of suggestion pills / collections),
       append closest / same-series / popular product rows and cancel the empty-state auto-redirect. */
    function skhAppendFallback(fbQ) {
      if (!localReady || typeof skFallback !== 'function') return;
      skFallback(fbQ).then(function (fb) {
        if (!fb || !fb.recs.length || smInput.value.trim() !== fbQ) return;
        if (smBody.querySelector('[data-skh-fb]')) return;
        if (emptyRedirectTimer) { clearTimeout(emptyRedirectTimer); emptyRedirectTimer = null; }
        var fh = '<div class="skh-sr-section" data-skh-fb><div class="skh-sr-label"><span>' + escapeHtml(fb.label.charAt(0).toUpperCase() + fb.label.slice(1)) + '</span></div><div class="skh-sr-list">';
        var fbShown = fb.recs.slice(0, PRODUCT_LIMIT);
        for (var fi = 0; fi < fbShown.length; fi++) { var fr = fbShown[fi]; fh += buildRow({ url: fr.url, title: fr.title, image: fr.img, vendor: fr.vendor, productType: fr.product_type, price: '', kind: 'product' }, fbQ, fi === 0 && !smBody.querySelector('[data-skh-row].is-active')); }
        fh += '</div></div>';
        smBody.insertAdjacentHTML('beforeend', fh);
        currentRows = Array.prototype.slice.call(smBody.querySelectorAll('[data-skh-row]'));
        if (activeIndex < 0 && currentRows.length) activeIndex = 0;
      }).catch(function () {});
    }
    function renderCombined(q, local, suggestData) {
      if (emptyRedirectTimer) { clearTimeout(emptyRedirectTimer); emptyRedirectTimer = null; }
      var resources = (suggestData && suggestData.resources && suggestData.resources.results) || {};
      var collections = resources.collections || [], pages = resources.pages || [], articles = resources.articles || [], queries = resources.queries || [];
      var hasAny = local.products.length || collections.length || pages.length || articles.length || queries.length;
      var dymHtml = '';
      if (local.dym && local.dym.query && local.dym.query !== skNorm(q)) {
        dymHtml = ('<div class="skh-sr-section"><div class="skh-sr-dym">' + sanikbPublicText_header_1['header_027_html'] + '<button type="button" class="skh-sr-dym-link" data-skh-quick-query="') + escapeHtml(local.dym.query) + '">' + escapeHtml(local.dym.query) + '</button>?</div></div>';
      }
      if (!hasAny) {
        smBody.innerHTML = dymHtml + '<div class="skh-sr-section">' + emptyMarkup(q) + '</div>';
        bindQuickQueries(); currentRows = []; activeIndex = -1;
        skhAppendFallback(q); /* no-dead-end (2026-09-20) */
        if (!local.dym && /[a-z]/i.test(q) && (q.length >= 4 || q.indexOf(' ') >= 0)) {
          emptyRedirectTimer = setTimeout(function () {
            if (smInput.value.trim() === q && smModal.classList.contains('is-open')) { saveRecent(q); closeSm(); window.location.href = window.SanikbPublicI18n.url('/search') + '?q=' + encodeURIComponent(q); }
          }, EMPTY_REDIRECT_MS);
        }
        return;
      }
      var html = dymHtml;
      if (queries.length && !local.skuMode) {
        html += ('<div class="skh-sr-section"><div class="skh-sr-label"><span>' + sanikbPublicText_header_1['header_028_html'] + '</span></div><div class="skh-sr-pills">');
        queries.slice(0, 6).forEach(function (qi) { var text = qi.text || qi.styled_text || ''; html += '<button type="button" class="skh-sr-pill" data-skh-quick-query="' + escapeHtml(text) + '">' + highlight(text, q) + '</button>'; });
        html += '</div></div>';
      }
      if (local.products.length) {
        var firstActive = !(queries.length && !local.skuMode);
        var countNote = local.total > PRODUCT_LIMIT ? '<span class="skh-sr-count">' + local.total + (sanikbPublicText_header_1['header_029_html'] + '</span>') : '';
        html += '<div class="skh-sr-section"><div class="skh-sr-label"><span>' + (local.near ? sanikbPublicText_header_1['header_030_html'] : sanikbPublicText_header_1['header_031_html']) + '</span>' + countNote + '</div><div class="skh-sr-list">';
        var shown = local.products.slice(0, PRODUCT_LIMIT);
        for (var i = 0; i < shown.length; i++) {
          var rec = shown[i].rec;
          html += buildRow({ url: rec.url, title: rec.title, image: rec.img, vendor: rec.vendor, productType: rec.product_type, price: '', kind: 'product' }, q, i === 0 && firstActive);
        }
        html += '</div>';
        if (local.total > PRODUCT_LIMIT && !local.skuMode && /[a-z]/i.test(q)) html += '<a href="' + escapeHtml(window.SanikbPublicI18n.url('/search')) + '?q=' + encodeURIComponent(q) + ('&type=product&sk_match=1" class="skh-sr-viewall">' + sanikbPublicText_header_1['header_032_html']) + local.total + (sanikbPublicText_header_1['header_033_html'] + '</a>');
        html += '</div>';
      }
      if (collections.length) {
        html += ('<div class="skh-sr-section"><div class="skh-sr-label"><span>' + sanikbPublicText_header_1['header_034_html'] + '</span></div><div class="skh-sr-list">');
        collections.slice(0, 4).forEach(function (c) { html += buildRow({ url: c.url, title: c.title, kind: 'collection', kindLabel: sanikbPublicText_header_1['header_035_html'] }, q, false); });
        html += '</div></div>';
      }
      if (articles.length) {
        html += ('<div class="skh-sr-section"><div class="skh-sr-label"><span>' + sanikbPublicText_header_1['header_036_html'] + '</span></div><div class="skh-sr-list">');
        articles.slice(0, 4).forEach(function (a) { html += buildRow({ url: a.url, title: a.title, image: a.image || '', kind: 'article', kindLabel: sanikbPublicText_header_1['header_037_html'] }, q, false); });
        html += '</div></div>';
      }
      if (pages.length) {
        html += ('<div class="skh-sr-section"><div class="skh-sr-label"><span>' + sanikbPublicText_header_1['header_038_html'] + '</span></div><div class="skh-sr-list">');
        pages.slice(0, 4).forEach(function (pg) { html += buildRow({ url: pg.url, title: pg.title, kind: 'page', kindLabel: sanikbPublicText_header_1['header_039_html'] }, q, false); });
        html += '</div></div>';
      }
      smBody.innerHTML = html;
      bindQuickQueries();
      currentRows = Array.prototype.slice.call(smBody.querySelectorAll('[data-skh-row]'));
      activeIndex = currentRows.length ? 0 : -1;
      if (!local.products.length) skhAppendFallback(q); /* no-dead-end (2026-09-20): pills/collections only, zero products */
      updateActiveRow();
    }

    function fetchSuggestExtras(q) {
      if (activeFetch && activeFetch.abort) { try { activeFetch.abort(); } catch (e) {} }
      var controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      activeFetch = controller;
      var url = window.SanikbPublicI18n.url('/search/suggest.json?q=') + encodeURIComponent(q) + '&resources[type]=collection,page,article,query&resources[limit]=6&resources[options][unavailable_products]=last';
      return fetch(url, controller ? { signal: controller.signal } : {}).then(function (r) { if (!r.ok) throw new Error('suggest'); return r.json(); });
    }

    function legacySuggest(q) {
      var cached = cacheGet(q);
      if (cached) { smModal.classList.remove('is-loading'); smModal.setAttribute('aria-busy', 'false'); renderResults(cached, q); return; }
      if (activeFetch && activeFetch.abort) { try { activeFetch.abort(); } catch (e) {} }
      var controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      activeFetch = controller;
      if (loadingTimer) clearTimeout(loadingTimer);
      loadingTimer = setTimeout(function () { smModal.classList.add('is-loading'); smModal.setAttribute('aria-busy', 'true'); }, LOADING_DELAY_MS);
      var url = window.SanikbPublicI18n.url('/search/suggest.json?q=') + encodeURIComponent(q) + '&resources[type]=product,collection,page,article,query&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag,body';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (res) { if (!res.ok) throw new Error('x'); return res.json(); })
        .then(function (data) {
          if (smInput.value.trim() !== q) return;
          if (loadingTimer) { clearTimeout(loadingTimer); loadingTimer = null; }
          smModal.classList.remove('is-loading'); smModal.setAttribute('aria-busy', 'false');
          cacheSet(q, data); renderResults(data, q);
        })
        .catch(function (err) {
          if (smInput.value.trim() !== q) return;
          if (err && err.name === 'AbortError') return;
          if (loadingTimer) { clearTimeout(loadingTimer); loadingTimer = null; }
          smModal.classList.remove('is-loading'); smModal.setAttribute('aria-busy', 'false');
          renderError();
        });
    }

    function openSm(opener) {
      if (smModal.classList.contains('is-open')) return;
      smReturnFocus = opener || document.activeElement;
      document.querySelectorAll('.skh-nav-item.has-dd.is-open').forEach(function (item) {
        item.classList.remove('is-open');
        var trigger = item.querySelector('.skh-dd-toggle');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
      if (scrim) scrim.classList.add('is-open');
      header.classList.remove('is-mega-open');
      if (mdDrawer && mdDrawer.classList.contains('is-open')) {
        mdDrawer.classList.remove('is-open'); mdDrawer.setAttribute('aria-hidden', 'true');
      }
      smModal.classList.add('is-open'); smModal.setAttribute('aria-hidden', 'false');
      if (searchBtnDesktop) { searchBtnDesktop.classList.add('is-active'); searchBtnDesktop.setAttribute('aria-expanded', 'true'); }
      if (mobileMq.matches) document.body.classList.add('skh-md-locked');
      renderInitial();
      ensureIndex().catch(function () {});
      smFocusTimer = setTimeout(function () {
        if (!smModal.classList.contains('is-open') || smModal.classList.contains('skh-sm--inline')) return;
        try { smInput.focus({ preventScroll: true }); } catch (e) { smInput.focus(); }
      }, 60);
    }
    function closeSm(returnFocus) { clearAllTimers(); closeSearchDropdown(returnFocus); activeIndex = -1; }

    Array.prototype.forEach.call(smOpenBtns, function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (smModal.classList.contains('is-open')) closeSm(true); else openSm(btn); });
    });
    Array.prototype.forEach.call(smCloseBtns, function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); closeSm(true); });
    });
    document.addEventListener('pointerdown', function (e) {
      if (!smModal.classList.contains('is-open')) return;
      if (smModal.classList.contains('skh-sm--inline')) return;
      if (smModal.contains(e.target)) return;
      if (e.target.closest('[data-skh-search-open]')) return;
      closeSm();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && smModal.classList.contains('is-open') && !smModal.classList.contains('skh-sm--inline')) { e.preventDefault(); closeSm(true); }
      if ((e.metaKey || e.ctrlKey) && e.key && e.key.toLowerCase() === 'k') { e.preventDefault(); openSm(); }
    });
    window.addEventListener('resize', function () { if (smModal.classList.contains('is-open') && !smModal.classList.contains('skh-sm--inline')) closeSm(); });
    smBody.addEventListener('click', function (e) {
      var link = e.target.closest('a[href]');
      if (link) { var qNow = smInput.value.trim(); if (qNow) saveRecent(qNow); closeSm(); }
    });

    function renderInitial() {
      /* Inline drawer search: keep just the search box — no Recent/Popular until the user types */
      if (smModal.classList.contains('skh-sm--inline') && (!smInput.value || !smInput.value.trim())) { smBody.innerHTML = ''; currentRows = []; activeIndex = -1; return; }
      var recent = getRecent(); var html = '';
      if (recent.length) {
        html += ('<div class="skh-sr-section"><div class="skh-sr-label"><span>' + sanikbPublicText_header_1['header_040_html'] + '</span><button type="button" class="skh-sr-label-link" data-skh-clear-recent>' + sanikbPublicText_header_1['header_041_html'] + '</button></div><div class="skh-sr-pills">');
        recent.forEach(function (q) { html += '<button type="button" class="skh-sr-pill" data-skh-quick-query="' + escapeHtml(q) + '">' + escapeHtml(q) + '</button>'; });
        html += '</div></div>';
      }
      if (popular.length) {
        html += ('<div class="skh-sr-section"><div class="skh-sr-label"><span>' + sanikbPublicText_header_1['header_042_html'] + '</span></div><div class="skh-sr-pills">');
        popular.forEach(function (q) { html += '<button type="button" class="skh-sr-pill" data-skh-quick-query="' + escapeHtml(q) + '">' + escapeHtml(q) + '</button>'; });
        html += '</div></div>';
      }
      if (!html) html = ('<div class="skh-sr-state"><strong class="skh-sr-state-title">' + sanikbPublicText_header_1['header_043_html'] + '</strong>' + sanikbPublicText_header_1['header_044_html'] + '</div>');
      smBody.innerHTML = html;
      bindQuickQueries();
      currentRows = []; activeIndex = -1;
    }
    function bindQuickQueries() {
      var quicks = smBody.querySelectorAll('[data-skh-quick-query]');
      Array.prototype.forEach.call(quicks, function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var q = btn.getAttribute('data-skh-quick-query');
          smInput.value = q; smInput.dispatchEvent(new Event('input')); smInput.focus();
        });
      });
      var clearBtn = smBody.querySelector('[data-skh-clear-recent]');
      if (clearBtn) clearBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); clearRecent(); renderInitial(); });
    }
    function renderError() {
      smBody.innerHTML = ('<div class="skh-sr-section"><div class="skh-sr-state"><strong class="skh-sr-state-title">' + sanikbPublicText_header_1['header_045_html'] + '</strong>' + sanikbPublicText_header_1['header_046_html'] + '</div></div>');
      currentRows = []; activeIndex = -1;
    }
    function renderEmpty(q) {
      var qEsc = escapeHtml(q);
      smBody.innerHTML = ('<div class="skh-sr-section"><div class="skh-sr-state"><strong class="skh-sr-state-title">' + sanikbPublicText_header_1['header_022_html'] + '</strong>' + sanikbPublicText_header_1['header_023_html'] + '<span class="skh-sr-state-q">&ldquo;') + qEsc + ('&rdquo;</span>' + sanikbPublicText_header_1['header_047_html'] + '</div><a href="/search?q=') + encodeURIComponent(q) + ('" class="skh-sr-cta-primary"><span>' + sanikbPublicText_header_1['header_025_html'] + '<span class="skh-sr-cta-primary-q">&ldquo;') + qEsc + '&rdquo;</span></span><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 8h10M9 4l4 4-4 4"/></svg></a><br><a href="' + escapeHtml(quoteUrl) + ('" class="skh-sr-cta-secondary">' + sanikbPublicText_header_1['header_026_html'] + '</a></div>');
      currentRows = []; activeIndex = -1;
      if (/[a-z]/i.test(q) && (q.length >= 4 || q.indexOf(' ') >= 0)) {
        if (emptyRedirectTimer) clearTimeout(emptyRedirectTimer);
        emptyRedirectTimer = setTimeout(function () {
          if (smInput.value.trim() === q && smModal.classList.contains('is-open')) {
            saveRecent(q); closeSm(); window.location.href = window.SanikbPublicI18n.url('/search') + '?q=' + encodeURIComponent(q);
          }
        }, EMPTY_REDIRECT_MS);
      }
    }
    function buildRow(item, q, isFirst) {
      var thumbHtml = '';
      if (item.image) thumbHtml = '<div class="skh-sr-thumb"><img src="' + escapeHtml(item.image) + '" alt="" width="48" height="48" loading="lazy" onerror="this.style.display=\'none\'"></div>';
      else {
        var iconSvg = '';
        if (item.kind === 'article') iconSvg = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M4 3h12v14H4z"/><path d="M7 7h6M7 10h6M7 13h4"/></svg>';
        else if (item.kind === 'page') iconSvg = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M5 3h7l3 3v11H5z"/><path d="M12 3v3h3"/></svg>';
        else if (item.kind === 'collection') iconSvg = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 5h14v4H3zM3 11h14v4H3z"/></svg>';
        else iconSvg = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M4 7l6-3 6 3v9l-6 3-6-3z"/><path d="M4 7l6 3 6-3M10 10v9"/></svg>';
        thumbHtml = '<div class="skh-sr-thumb skh-sr-thumb--icon">' + iconSvg + '</div>';
      }
      var subParts = [];
      if (item.productType) subParts.push(escapeHtml(item.productType).toUpperCase());
      if (item.vendor) subParts.push(escapeHtml(item.vendor).toUpperCase());
      var sub = subParts.length ? subParts.join(' · ') : (item.kindLabel || '');
      var priceHtml = item.price ? '<div class="skh-sr-price">' + escapeHtml(item.price) + '</div>' : '';
      return '<a href="' + escapeHtml(window.SanikbPublicI18n.url(item.url)) + '" class="skh-sr-row' + (isFirst ? ' is-active' : '') + '" data-skh-row tabindex="-1">' + thumbHtml + '<div class="skh-sr-meta"><div class="skh-sr-title">' + highlight(item.title, q) + '</div>' + (sub ? '<div class="skh-sr-sub">' + sub + '</div>' : '') + '</div>' + priceHtml + '<span class="skh-sr-row-arrow">→</span></a>';
    }
    function formatMoney(amount, currency) {
      if (amount == null) return '';
      var n = parseFloat(amount);
      if (!isFinite(n) || n <= 0) return '';
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD', maximumFractionDigits: 0 }).format(n); }
      catch (e) { return '$' + n.toFixed(0); }
    }
    function renderResults(data, q) {
      var resources = (data && data.resources && data.resources.results) || {};
      var products = resources.products || [], collections = resources.collections || [];
      var pages = resources.pages || [], articles = resources.articles || [], queries = resources.queries || [];
      var anything = products.length || collections.length || pages.length || articles.length || queries.length;
      if (!anything) { renderEmpty(q); return; }
      var html = '';
      if (queries.length) {
        html += ('<div class="skh-sr-section"><div class="skh-sr-label"><span>' + sanikbPublicText_header_1['header_028_html'] + '</span></div><div class="skh-sr-pills">');
        queries.slice(0, 6).forEach(function (qi) { var text = qi.text || qi.styled_text || ''; html += '<button type="button" class="skh-sr-pill" data-skh-quick-query="' + escapeHtml(text) + '">' + highlight(text, q) + '</button>'; });
        html += '</div></div>';
      }
      if (products.length) {
        html += ('<div class="skh-sr-section"><div class="skh-sr-label"><span>' + sanikbPublicText_header_1['header_048_html'] + '</span></div><div class="skh-sr-list">');
        products.slice(0, 6).forEach(function (p, i) {
          var img = ''; if (p.featured_image && p.featured_image.url) img = p.featured_image.url; else if (p.image) img = p.image;
          var price = formatMoney(p.price, p.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active));
          html += buildRow({ url: p.url, title: p.title, image: img, vendor: p.vendor || '', productType: p.product_type || '', price: price, kind: 'product' }, q, i === 0 && queries.length === 0);
        });
        html += '</div><a href="/search?q=' + encodeURIComponent(q) + ('&type=product" class="skh-sr-viewall">' + sanikbPublicText_header_1['header_049_html'] + '</a></div>');
      }
      if (collections.length) {
        html += ('<div class="skh-sr-section"><div class="skh-sr-label"><span>' + sanikbPublicText_header_1['header_034_html'] + '</span></div><div class="skh-sr-list">');
        collections.slice(0, 4).forEach(function (c) { html += buildRow({ url: c.url, title: c.title, kind: 'collection', kindLabel: sanikbPublicText_header_1['header_035_html'] }, q, false); });
        html += '</div></div>';
      }
      if (articles.length) {
        html += ('<div class="skh-sr-section"><div class="skh-sr-label"><span>' + sanikbPublicText_header_1['header_036_html'] + '</span></div><div class="skh-sr-list">');
        articles.slice(0, 4).forEach(function (a) { html += buildRow({ url: a.url, title: a.title, image: a.image || '', kind: 'article', kindLabel: sanikbPublicText_header_1['header_037_html'] }, q, false); });
        html += '</div></div>';
      }
      if (pages.length) {
        html += ('<div class="skh-sr-section"><div class="skh-sr-label"><span>' + sanikbPublicText_header_1['header_038_html'] + '</span></div><div class="skh-sr-list">');
        pages.slice(0, 4).forEach(function (pg) { html += buildRow({ url: pg.url, title: pg.title, kind: 'page', kindLabel: sanikbPublicText_header_1['header_039_html'] }, q, false); });
        html += '</div></div>';
      }
      smBody.innerHTML = html;
      bindQuickQueries();
      currentRows = Array.prototype.slice.call(smBody.querySelectorAll('[data-skh-row]'));
      activeIndex = currentRows.length ? 0 : -1;
      updateActiveRow();
    }
    function updateActiveRow() {
      currentRows.forEach(function (row, i) { row.classList.toggle('is-active', i === activeIndex); });
      if (activeIndex >= 0 && currentRows[activeIndex]) {
        var el = currentRows[activeIndex];
        var rect = el.getBoundingClientRect(); var bodyRect = smBody.getBoundingClientRect();
        if (rect.bottom > bodyRect.bottom || rect.top < bodyRect.top) el.scrollIntoView({ block: 'nearest' });
      }
    }
    function performSearch(q) {
      if (localReady) {
        if (loadingTimer) { clearTimeout(loadingTimer); loadingTimer = null; }
        smModal.classList.remove('is-loading'); smModal.setAttribute('aria-busy', 'false');
        var local = searchLocal(q);
        var cached = cacheGet(q);
        renderCombined(q, local, cached);
        if (!cached) {
          fetchSuggestExtras(q).then(function (data) {
            if (smInput.value.trim() !== q) return;
            cacheSet(q, data); renderCombined(q, searchLocal(q), data);
          }).catch(function () {});
        }
        return;
      }
      /* index still building — show loader, then re-run. Permanent fallback to Shopify if products.json is blocked. */
      if (loadingTimer) clearTimeout(loadingTimer);
      loadingTimer = setTimeout(function () { smModal.classList.add('is-loading'); smModal.setAttribute('aria-busy', 'true'); }, LOADING_DELAY_MS);
      ensureIndex().then(function () {
        if (loadingTimer) { clearTimeout(loadingTimer); loadingTimer = null; }
        smModal.classList.remove('is-loading'); smModal.setAttribute('aria-busy', 'false');
        if (smInput.value.trim() === q) performSearch(q);
      }).catch(function () {
        if (loadingTimer) { clearTimeout(loadingTimer); loadingTimer = null; }
        if (smInput.value.trim() === q) legacySuggest(q);
      });
    }
    smInput.addEventListener('input', function () {
      var q = smInput.value.trim();
      userMovedSelection = false;
      if (smClear) smClear.style.display = q ? 'flex' : 'none';
      if (emptyRedirectTimer) { clearTimeout(emptyRedirectTimer); emptyRedirectTimer = null; }
      if (q === lastQuery) return;
      lastQuery = q;
      if (debounceTimer) clearTimeout(debounceTimer);
      if (!q || q.length < 2) {
        if (loadingTimer) { clearTimeout(loadingTimer); loadingTimer = null; }
        smModal.classList.remove('is-loading'); smModal.setAttribute('aria-busy', 'false');
        renderInitial(); return;
      }
      debounceTimer = setTimeout(function () { performSearch(q); }, SEARCH_DEBOUNCE_MS);
    });
    if (smClear) smClear.addEventListener('click', function (e) {
      e.preventDefault(); smInput.value = ''; smClear.style.display = 'none';
      smInput.dispatchEvent(new Event('input')); smInput.focus();
    });
    smForm.addEventListener('submit', function (e) {
      var q = smInput.value.trim();
      if (!q) { e.preventDefault(); return; }
      saveRecent(q); closeSearchDropdown();
    });
    smInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        var q = smInput.value.trim();
        /* only dive into a specific row if the user explicitly arrowed to it; plain Enter goes to the full results page */
        if (userMovedSelection && currentRows.length && activeIndex >= 0) {
          e.preventDefault(); if (q) saveRecent(q);
          var href = currentRows[activeIndex].getAttribute('href'); closeSm(); window.location.href = href; return;
        }
        if (q) saveRecent(q);
        return; /* let the form submit to routes.search_url?q=… (the custom results page) */
      }
      if (!currentRows.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); userMovedSelection = true; activeIndex = Math.min(activeIndex + 1, currentRows.length - 1); updateActiveRow(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); userMovedSelection = true; activeIndex = Math.max(activeIndex - 1, 0); updateActiveRow(); }
    });
  });

  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = this.querySelector('.skh') ? this.querySelector('.skh').parentElement : this;
      this.sectionRoot = this.closest('[id^="shopify-section-"]') || this.header;
      this.headerIsAlwaysSticky = true;
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.keepVisible();
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.keepVisible.bind(this));
    }
    disconnectedCallback() { window.removeEventListener('scroll', this.onScrollHandler); }
    keepVisible() {
      var skh = this.querySelector('.skh') || document.querySelector('.skh');
      var h = Math.ceil((skh && skh.offsetHeight) || this.offsetHeight || 80);
      document.documentElement.style.setProperty('--header-height', h + 'px');
      document.documentElement.style.setProperty('--skh-header-height', h + 'px');
      document.documentElement.style.setProperty('--skh-fixed-offset', h + 'px');
      if (document.body) document.body.style.setProperty('--skh-fixed-offset', h + 'px');

      [this.sectionRoot, this.header].forEach(function (el) {
        if (!el) return;
        el.classList.add('shopify-section-header-sticky');
        el.classList.remove('shopify-section-header-hidden');
        el.style.transform = 'none';
        el.style.opacity = '1';
        el.style.visibility = 'visible';
      });
    }
    setHeaderHeight() { this.keepVisible(); }
    createObserver() {}
    onScroll() {
      this.keepVisible();
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    }
    hide() { this.keepVisible(); }
    reveal() { this.keepVisible(); }
    reset() { this.keepVisible(); }
  }
  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
